import { DEFAULT_COUNTRY_CODES, type CountryCode } from '../constants/countries';

const countryCodeSet = new Set<string>(DEFAULT_COUNTRY_CODES);

export function isCountryCode(value: string): value is CountryCode {
  return countryCodeSet.has(value);
}

export function toCountryCode(value: string | null | undefined): CountryCode | null {
  if (typeof value !== 'string' || !isCountryCode(value)) return null;
  return value;
}

export function toCountryCodes(values: string[] | null | undefined): CountryCode[] {
  if (!values) return [];
  return values.filter(isCountryCode);
}
